import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { platformAPI } from '../services/platformAPI';
import { userHasAnyPermission } from '../utils/permissions';

let cache = null;
let inflight = null;
const listeners = new Set();

function publish(permissions) {
  cache = permissions;
  listeners.forEach((listener) => listener(permissions));
}

export function clearWorkspaceAccess() {
  cache = null;
  inflight = null;
  listeners.forEach((listener) => listener(null));
}

export function useWorkspaceAccess() {
  const user = useSelector((state) => state.auth.user);
  const fallback = user?.permissions || [];
  const [permissions, setPermissions] = useState(cache || fallback);
  const [ready, setReady] = useState(cache != null);

  useEffect(() => {
    let active = true;
    const load = () => {
      const stored = user?.permissions || [];
      if (!inflight) {
        inflight = platformAPI.bootstrap()
          .then((response) => response.data?.data?.permissions || stored)
          .catch(() => stored)
          .then((next) => {
            publish(next);
            return next;
          });
      }
      return inflight;
    };
    const apply = (next) => {
      if (!active) return;
      if (next == null) {
        setReady(false);
        load().then(apply);
        return;
      }
      setPermissions(next);
      setReady(true);
    };
    listeners.add(apply);
    if (cache) apply(cache);
    else load().then(apply);
    return () => {
      active = false;
      listeners.delete(apply);
    };
  }, [user?._id, user?.id]);

  return {
    permissions,
    ready,
    allowed: (keys) => userHasAnyPermission(permissions, keys || [])
  };
}
